import DialogContainer from './containers/DialogContainer';

export default DialogContainer;
